import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { t } from '../utils/translations';

const CookieBanner = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie_consent', 'essential_only');
    setVisible(false);
  };

  return (
    <AnimatePresence>
    {visible && (
    <motion.div
      initial={{ y: '100%' }}
      animate={{ y: 0 }}
      exit={{ y: '100%' }}
      transition={{ duration: 0.4, ease: [0.32, 0.72, 0, 1] }}
      style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(6, 6, 14, 0.98)',
      borderTop: '1px solid rgba(0,255,200,0.2)',
      padding: '20px',
      zIndex: 9999,
      backdropFilter: 'blur(10px)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '20px',
        flexWrap: 'wrap'
      }}>
        <div style={{ flex: '1 1 300px' }}>
          <p style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '14px',
            color: '#ccc',
            margin: 0,
            lineHeight: '1.5'
          }}>
            {t('cookies.text', language)} {t('cookies.readPolicy', language)}{' '}
            <Link to="/privacy" style={{ color: '#00ffc8', textDecoration: 'none' }}>
              {t('cookies.privacyPolicy', language)}
            </Link>
            .
          </p>
        </div>
        
        <div style={{
          display: 'flex',
          gap: '12px',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={handleReject}
            style={{
              padding: '10px 20px',
              background: 'transparent',
              border: '1px solid #00ffc8',
              borderRadius: '6px',
              color: '#00ffc8',
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '12px',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'all 0.2s ease'
            }}
            className="pressable"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(0,255,200,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
            }}
          >
            {t('cookies.reject', language)}
          </button>
          
          <button
            onClick={handleAccept}
            style={{
              padding: '10px 20px',
              background: '#00ffc8',
              border: 'none',
              borderRadius: '6px',
              color: '#06060e',
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '12px',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'all 0.2s ease'
            }}
            className="pressable"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#00ddaa';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#00ffc8';
            }}
          >
            {t('cookies.accept', language)}
          </button>
        </div>
      </div>
    </motion.div>
    )}
    </AnimatePresence>
  );
};

export default CookieBanner;
